
@if(showBanner){
  <ng-container>
    <div div @slideUp style="position: absolute; bottom: 0; background-color: #eeeeee; z-index: 10000; margin: auto; text-align: center; padding: 40px 10px 20px 10px; width: 100%; left:0;">
      <button (click)="close()" style="position: absolute; top: 3px; right: 3px; background: none; border: none; font-size: 16px; color: #888; cursor: pointer;">✕</button>
      <!--<h2>{{ 'Intellitrailer.Booking.AnimatedCampaignCard.titleOfferRecived' | translate: 'You’ve Got an Offer!' }}</h2>
      <p>{{ 'Intellitrailer.Booking.AnimatedCampaignCard.txtOfferRecived' | translate: 'Something new is waiting. Tap to explore your offer' }}</p>-->
    <h2> {{campaing.Title}} </h2>
    <p> {{campaing.Comment}} </p>
      <div class="row">

        <div class="col">
          <!--<button (click)="navigateToOffer()" style="min-height:40px" mat-raised-button> {{'Intellitrailer.Booking.AnimatedCampaignCard.btnShowMe' | translate : 'Show me!'}}</button>-->

          @if(actionExist){
          <button (click)="openAction()" style="min-height:40px" mat-raised-button> {{'Intellitrailer.Booking.AnimatedCampaignCard.btnShowMe' | translate : 'Show me!'}}</button>
          }
          @else{
          <button (click)="close()" style="min-height:40px" mat-raised-button>{{'Intellitrailer.Booking.AnimatedCampaignCard.btnClose' | translate : 'Close'}}</button>
          }
        </div>
      </div>
    </div>
  </ng-container>
}
